import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import { Productbtn } from "../../../../../../shared/services/interface";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { borderHighlightOptions } from "src/shared/modules/profile/theme/themeConstants";
import { useUser } from "src/business-types/grocery/components/UserContext";

interface ProductItemProps {
  product: Productbtn;
  quantity: number;
  onQuantityChange: (productId: string, amount: string, type: "add" | "subtract") => void;
  onProductRemove: (id: string, amount: string) => void;
}

const ProductItem: React.FC<ProductItemProps> = ({ product, quantity, onQuantityChange, onProductRemove }) => {
  const { user } = useUser();

  const themeKey = user?.background_colour || "DodgerBlue";
  const highlightClass = borderHighlightOptions[themeKey];
  const { bgClass, fontClass } = useUserTheme();

  return (
    <div
      className={`relative flex flex-col sm:flex-row sm:items-center justify-between rounded-xl p-2 sm:p-2 mb-2 shadow-md hover:shadow-lg transition-all duration-200 bg-gray-50 border-2 
       ${fontClass} ${highlightClass ? `${highlightClass} ring-1 ring-opacity-40` : "border-transparent"}`}
    >
      <button onClick={() => onProductRemove(product._id.$oid, product.Amount)}
        className="absolute -top-1.5 -right-1.5 sm:-top-1 sm:-right-1 flex items-center justify-center w-6 h-6 rounded-full bg-red-100 text-red-600 border border-red-200 hover:bg-red-600 hover:text-white hover:scale-110 transition-all duration-200 shadow-sm">
        <CloseIcon fontSize="small" />
      </button>

      <div className="flex flex-col flex-1 min-w-0 pr-6 sm:pr-0">
        <p className={`text-base font-semibold truncate text-gray-800`}>{product.ProductName}</p>
        {product.ArabicName && <p className="text-sm text-gray-700 truncate leading-tight mt-1">{product.ArabicName}</p>}
      </div>

      <div className="flex items-center justify-between sm:justify-end gap-4 mt-3 sm:mt-0 sm:ml-4 sm:min-w-[240px] w-full sm:w-auto">
        <div className="flex items-center gap-2">
          <button className={`rounded-full p-1 hover:opacity-90 transition-all ${bgClass}`} onClick={() => onQuantityChange(product._id.$oid, product.Amount, "subtract")} id="remove-icon-button">
            <RemoveIcon fontSize="small" />
          </button>
          <span className="px-3 py-1 rounded text-center min-w-[38px] border border-gray-300 text-sm text-bold sm:text-base font-bold bg-white shadow-md">{quantity}</span>
          <button className={`rounded-full p-1 hover:opacity-90 transition-all ${bgClass}`} onClick={() => onQuantityChange(product._id.$oid, product.Amount, "add")} id="add-icon-button">
            <AddIcon fontSize="small" />
          </button>
        </div>

        <p className="text-[#D70015] font-semibold text-sm sm:text-base text-right min-w-[110px]">{(quantity * parseFloat(product.Amount)).toFixed(2)} QAR</p>
      </div>
    </div>
  );
};

export default ProductItem;